import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { PsRoutes } from '../shared/routing/Routes';
import UsersScreen from './screens/UsersScreen';
import AddUserScreen from './screens/AddUserScreen';
import UserDetailScreen from './screens/UserDetailScreen';

export class UsersRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if ( currentUser.isSuperAdmin() || currentUser.isAdmin() ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.USERS} component={UsersScreen}/>
                    <Route exact path={PsRoutes.USERS_ADD} component={AddUserScreen}/>
                    <Route exact path={PsRoutes.USERS_DETAIL} component={UserDetailScreen}/>
                </React.Fragment>
            );
        }

        return null;
    }
}

UsersRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/users/UsersRouting.jsx